import { CSSResultGroup, html, LitElement } from "lit"
import { customElement, property } from "lit/decorators.js"
import { chevronSvg } from "../assets/svg-ts/chevron";
import { globalStyles } from "../styles";

interface Product {
  uniqueKey: string,
  name: string
}

@customElement("dev-console-list-item")
export class DevConsoleListItem extends LitElement {
    static override styles?: CSSResultGroup | undefined = [globalStyles];
    @property({ attribute: ".product"})
    product : Product = {
      uniqueKey: "",
      name: ""
    }

    @property()
    isMobile = false

    @property()
    activeProductKey = ""

    @property()
    mobileClosedProduct = ""
    
    checkActive(){
      let result = false;
      if(this.activeProductKey === this.product.uniqueKey) result = true;
      if(this.isMobile && this.mobileClosedProduct === this.product.uniqueKey) result = false;

      return result;
    }

    override render() {
        return html`
            <li
                class="flex items-center justify-between text-sm font-semibold px-6 py-2 cursor-pointer group hover:bg-highlight"
                value=${this.product.uniqueKey}
                @click=${() => this._dispatchItemSelect(this.product.uniqueKey)}
            >
              <div class="flex space-x-2 items-center">
                <img
                src="https://dev.assets.developer.tech.gov.sg/svg/products/${this.product.uniqueKey}.inline.svg"
                />
                <p class="text-sm font-semibold  ${this.checkActive() ? "text-highlight" : "text-gray-700"} group-hover:text-white">${this.product.name}</p>
              </div>
              <div class="md:hidden w-6 group-hover:text-white ${this.checkActive() ? "rotate-180 text-highlight":"rotate-0 text-gray-700"}">
                  ${chevronSvg}
              </div>
            </li>
            ${this.checkActive() ? html`
              <slot name="product-details"></slot>  
            `: html``}   
        `
    }

    private _dispatchItemSelect(uniqueKey: string) {
        if (uniqueKey) {
          const options = {
            detail: { uniqueKey, fromMobile: this.isMobile },
            bubbles: true,
            composed: true,
          };
          this.dispatchEvent(new CustomEvent("itemSelect", options));
        }
      }
}

declare global {
    interface HTMLElementTagNameMap {
      "dev-console-list-item": DevConsoleListItem;
    }
  }